import React from 'react';
import FontAwesome from 'react-fontawesome';

const BookingsViewSwitch = ({ view, previousLabel, upcomingLabel, onSwitch }) => {
    let viewButton, newView, disablePrevious, disableUpcoming;
    switch (view) {
        case BookingView.UPCOMING:
            viewButton = previousLabel;
            newView = BookingView.PREVIOUS;
            disableUpcoming = true;
            break;
        case BookingView.PREVIOUS:
            viewButton = upcomingLabel;
            newView = BookingView.UPCOMING;
            disablePrevious = true;
            break;
    }

    const iconStyle = {
        width: 35,
        height: 35,
        lineHeight: '35px',
        fontSize: 16,
        marginTop: '-5px'
    }

    return <span>
        <button disabled={disablePrevious} className={`pull-left circle-icon bg-light ${disablePrevious ? 'disabled' : ''}`} style={iconStyle}
            onClick={() => onSwitch(newView)}><FontAwesome name='arrow-left' /></button>
        <a className='no-decoration' onClick={() => onSwitch(newView)} style={{ cursor: 'pointer', margin: '0 15px', fontSize: 15 }}><b>{viewButton}</b></a>
        <button disabled={disableUpcoming} className={`pull-right circle-icon bg-light ${disableUpcoming ? 'disabled' : ''}`} style={iconStyle}
            onClick={() => onSwitch(newView)}><FontAwesome name='arrow-right' /></button>
    </span>;
};

export const BookingView = {
    UPCOMING: 'upcoming',
    PREVIOUS: 'previous'
};

export default BookingsViewSwitch;